module.exports = __webpack_public_path__ + "static/media/SafetyNest_Purple_Positive_RGB.5aaac363.svg";